const selectors = {
    TOOLBAR_BUTTON: 'toolbar-button',
    TOOLBAR_BUTTON_BORDER: 'toolbar-button-border'
}

export default selectors;